//////////////////////////////////////////////////////////////////////////////
//
//  FAQ API
//
//  작성자: MediInStep Team
//  생성일: 2026-01-07
//
//  설명: FAQ 관리 관련 API 정의
//
//////////////////////////////////////////////////////////////////////////////

import { ApiGroup } from "../types/ApiTypes"

/**
 * FAQ 관리 관련 API
 */
const FaqAPI: ApiGroup = {
    pagedList: {
        title: "FAQ 목록 조회",
        url: "/FAQ/PagedList",
        method: "POST",
        paramz: {},
    },
    list: {
        title: "전체 FAQ 목록 조회",
        url: "/FAQ/List",
        method: "GET",
        paramz: {},
    },
    getById: {
        title: "FAQ 상세 조회",
        url: "/FAQ/:id",
        method: "GET",
        paramz: {},
        pathParams: ["id"],
    },
    create: {
        title: "FAQ 등록",
        url: "/FAQ",
        method: "POST",
        paramz: {},
    },
    update: {
        title: "FAQ 수정",
        url: "/FAQ/:id",
        method: "PUT",
        paramz: {},
        pathParams: ["id"],
    },
    updateDisplayOrder: {
        title: "FAQ 순서 변경",
        method: "PUT",
        url: "/FAQ/UpdateDisplayOrder",
        paramz: {},
    },
    delete: {
        title: "FAQ 삭제",
        url: "/FAQ/:id",
        method: "DELETE",
        paramz: {},
        pathParams: ["id"],
    },
}

export default FaqAPI
